import React from 'react';
import { Field } from 'formik';
import { Form, InputGroup } from 'react-bootstrap';

const ReactstrapFormikInputCheckbox = ({
    field: { ...fields },
    form: { values, touched, errors, setFieldValue, setFieldTouched },
    ...props
}) => {
    const { id, ...rest } = props;
    const isCheckboxName = `is_${fields.name}`;
    return (
        <Form.Group controlId={id} className="form-group">
            {props.label && <Form.Label className={'label-color'}>{props.label}</Form.Label>}
            <InputGroup>
                <div className="input-group-prepend">
                    <InputGroup.Text>
                        <Field
                            name={isCheckboxName}
                            render={({ field }) => (
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        disabled={props.isDisable ? true : false}
                                        className="custom-control-input"
                                        id={isCheckboxName}
                                        checked={field.value}
                                        {...field}
                                        onChange={(e) => {
                                            if (!e.target.checked) {
                                                setFieldValue(fields.name, '');
                                            }
                                            setFieldValue(isCheckboxName, e.target.checked);
                                        }}
                                        onBlur={() => {
                                            setFieldTouched(isCheckboxName, true);
                                        }}
                                    />
                                    <label className="custom-control-label pb-0" htmlFor={isCheckboxName}></label>
                                </div>
                            )}
                        />
                    </InputGroup.Text>
                </div>
                <Form.Control
                    {...fields}
                    {...rest}
                    disabled={!values[isCheckboxName]}
                    isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                />
            </InputGroup>
            {touched[fields.name] && errors[fields.name] && errors[fields.name] !== 'required' && (
                <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                    {errors[fields.name]}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};
export default ReactstrapFormikInputCheckbox;
